<template>
  <div class="mt-4">
    <option-list
      :options="this.components.frame[1]"
      :inputName="'frameFinish'"
      :target="this.results.frame.finish"
      v-on:target-updated="updateData"
    ></option-list>
  </div>
</template>

<script>
import OptionList from "../../../shared/optionList.vue";

export default {
  name: "frame-frame-finish",
  components: {
    OptionList,
  },
  data() {
    return {};
  },
  props: ["results", "components"],
  computed: {
    frameFinish: {
      get: function () {
        return this.results.frame.finish;
      },
      set: function (e) {
        this.$emit("set-frame-finish", e);
      },
    },
  },
  methods: {
    updateData: function (e) {
      this.frameFinish = e;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>